import { HStack, Text, VStack } from '@chakra-ui/react';
import { EditCheck, Shield } from '@time-line/components/icons';
import { SUBSCRIPTION_CANCELLATION_NOTE } from 'lib/constants/products';

interface CartLineItemInfoBulletsProps {
  isMoneyBackGuarantee: boolean;
  isSubscription: boolean;
}

export function CartLineItemInfoBullets({
  isMoneyBackGuarantee,
  isSubscription,
}: CartLineItemInfoBulletsProps) {
  if (!isMoneyBackGuarantee && !isSubscription) return null;

  return (
    <VStack alignItems="flex-start" as="ul" spacing="2px" mb="3xs">
      {isMoneyBackGuarantee && (
        <HStack as="li" gap="4xs">
          <Shield boxSize="2xs" />
          <Text size="detail" fontWeight="medium">
            30 day money-back guarantee
          </Text>
        </HStack>
      )}
      {isSubscription && (
        <HStack as="li" gap="4xs">
          <EditCheck boxSize="2xs" />
          <Text size="detail" fontWeight="medium">
            {SUBSCRIPTION_CANCELLATION_NOTE}
          </Text>
        </HStack>
      )}
    </VStack>
  );
}
